export async function copyTextWithSelectionFallback(
  value: string,
  input: HTMLInputElement | null,
): Promise<boolean> {
  if (input) {
    input.focus();
    input.select();
    input.setSelectionRange(0, value.length);
    try {
      if (document.execCommand('copy')) return true;
    } catch {
      // Continue to the modern Clipboard API.
    }
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // Hosted iframe policies can reject Clipboard API writes even during a user gesture.
  }

  window.prompt('Copy link', value);
  return false;
}
